import { render, staticRenderFns } from "./RegulationsNomenclaturesGrid.vue?vue&type=template&id=6f33f9f8&"
import script from "./RegulationsNomenclaturesGrid.vue?vue&type=script&lang=js&"
export * from "./RegulationsNomenclaturesGrid.vue?vue&type=script&lang=js&"
import style0 from "./RegulationsNomenclaturesGrid.vue?vue&type=style&index=0&id=6f33f9f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports